// src/pages/Users/Galleries/components/EmptyState.jsx
import React from "react";

export default function EmptyState({ message = "Aucun album à afficher" }) {
  return (
    <div className="text-center py-16">
      <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 mb-4" />
      <h4 className="text-lg font-semibold mb-1">{message}</h4>
      <p className="text-slate-600 dark:text-slate-300">
        Modifiez la recherche, le tri ou l’affichage.
      </p>
    </div>
  );
}
